export default __webpack_public_path__ + "static/media/discovery-logo.0fef8d41.jpg";